import Logo from 'components/shared/Logo';
import * as styles from './MinimalHeader.module.scss';

export default function MinimalHeader() {
  return (
    <header className={styles.header}>
      <Logo />
    </header>
  );
}
